import { render, staticRenderFns } from "./header-bar.vue?vue&type=template&id=edfc37ae"
import script from "./header-bar.vue?vue&type=script&lang=ts"
export * from "./header-bar.vue?vue&type=script&lang=ts"
import style0 from "./header-bar.vue?vue&type=style&index=0&id=edfc37ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports